/** Public pagination URLs must be stable and work without JavaScript. */
export function parsePageNumber(value?: string | string[]): number {
  if (value === undefined) return 1;
  if (typeof value !== "string" || !/^[1-9]\d*$/.test(value)) return 0;
  const page = Number(value);
  return Number.isSafeInteger(page) ? page : 0;
}

export function splitPageSegments(segments: string[]): {
  segments: string[];
  page: number;
  explicit: boolean;
} {
  const index = segments.lastIndexOf("page");
  // A terminal place slug may itself be "page" (for example Page, Arizona).
  if (index === -1 || (index === segments.length - 1 && segments.length > 2))
    return { segments, page: 1, explicit: false };
  return {
    segments: segments.slice(0, index),
    page:
      index === segments.length - 2 ? parsePageNumber(segments[index + 1]) : 0,
    explicit: true,
  };
}

export function pagePath(basePath: string, page: number): string {
  return page === 1 ? basePath : `${basePath}/page/${page}`;
}

export function blogPagePath(basePath: string, page: number): string {
  return page === 1 ? basePath : `${basePath}?page=${page}`;
}

export function isPageInRange(
  page: number,
  total: number,
  limit: number,
): boolean {
  return (
    Number.isSafeInteger(page) &&
    page >= 1 &&
    page <= Math.max(1, Math.ceil(total / limit))
  );
}
